import { StatusBadge } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { cardStatusBadgeColor } from '@/features/cards/components/CardUI/PaymentCardUI';
import { CardStatusColor, TCardStatus } from '@/features/cards/store/models/card.model';

export function CardStatus({ status }: { status: TCardStatus }) {
  const { t } = useTranslation();

  const colorStatus = CardStatusColor[status];

  return (
    <StatusBadge color={cardStatusBadgeColor[colorStatus]} label={t(`monetics.card.status.${status}`)} emphasis="low" />
  );
}
